import { Component, OnInit, ViewChild, Inject, ChangeDetectorRef, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl, FormGroupDirective } from '@angular/forms';
import { HttpService } from "../../shared/services/http.service";
import { NgxSpinnerService } from "ngx-spinner";
import { HelperService } from 'app/helper.service';
import { prepareEventListenerParameters } from '@angular/compiler/src/render3/view/template';
import { BehaviorSubject } from 'rxjs';
import { BarcodeFormat } from '@zxing/library';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';



@Component({
  selector: 'standard-inspection',
  templateUrl: './standard-inspection.component.html',
  styleUrls: ['./standard-inspection.component.scss'],
})


export class StandardInspectionComponent implements OnInit {

  @ViewChild('userDform', { static: true }) form;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
@ViewChild(MatSort, { static: false }) sort: MatSort;
repairRecords: any[] = [];
dataSource: MatTableDataSource<any>;
count = 1;
hasMoreRecords = false;
displayedColumns = [
  'recordId',
  'description',
  'createdBy',
  'serialNumber',
  'startTime'
];
  standardInspectionForm: FormGroup;
  isChecked: boolean = true;
  ok: any;
  notOk: any;
  showClassification: boolean = false;
  showProblemFixed: boolean = false;
  showMixerZone:boolean = false;
  filesList: any = [];
  firstParam: any;
  projectItemCodes: any;
  responseMessage: any;
  classificationValues:any = [];
  mixerzoneValues:any=[];
  inspectionType:any;
  projectName:any = "";
  projectCategoryCode:any;
  fileSizeError: string = '';
  scanStart:boolean=false; 
  scanSerialStart: boolean = false;
  qrResultString: string;
  availableDevices: MediaDeviceInfo[];
  hasDevices: boolean;
  qrResults: any=[];
  currentDevice: MediaDeviceInfo = null;
  hasPermission: boolean;
  torchAvailable$ = new BehaviorSubject<boolean>(false);
  torchEnabled = false;
  tryHarder = false;
  recordCount=0;
    totalCount: any;
    category: any;

    recordDetailID: any;
    recordDetailsHolderNumber: any;
    recordDetailDescription: any;
    recordDetailstartDate: any;
    recordDetailfileUrls: any = [];
    recordDetailcloseRecord: any;
    recordDetailsByID: any;
    recordDetailItemCode: any;
    recordDetailClassification: any;
    recordDetailQuality: any;
    recordDetailProblemFixed: any;
    recordDetailMixerZone: any;


  formatsEnabled: BarcodeFormat[] = [
    BarcodeFormat.CODE_128,
    BarcodeFormat.DATA_MATRIX,
    BarcodeFormat.EAN_13,
    BarcodeFormat.QR_CODE,
  ];
  // Barcode scanning variables end

  constructor(private route: ActivatedRoute, private fb: FormBuilder, private httpService: HttpService, private spinner: NgxSpinnerService, private helperservice: HelperService, private cdr: ChangeDetectorRef) {

  }

  ngOnInit() {
    this.firstParam = this.route.snapshot.queryParamMap.get('projectID');
    this.getProjectDetails();
    this.getClassifications();
    this.getMixerZoneValues();
    this.fetchRepairRecords();

    this.standardInspectionForm = this.fb.group({
      itemcode: ['', [Validators.required]],
      holderNumber: ['', [Validators.required, Validators.maxLength(20), Validators.minLength(9)]],
      serialNumber: [''],
      label: ['OK', [Validators.required]],
      classification: [''],
      description:[''],
      problem: ['NO'],
      mixerzone:['']
    });
    // this.standardInspectionForm.reset();
    
  }

  getProjectDetails() {
    this.spinner.show();
    this.httpService.getRequest('specialProjectApi/v1/projectDetails?projectId=' + this.firstParam).subscribe(
      res => {
        this.spinner.hide();
        if(res['status'] === 'ERROR'){
          this.responseMessage = res['errorMessage'];
          this.helperservice.openStaticModal('ConfirmDialog');
          return;
        }
        this.projectItemCodes = res['projectDetails']['projectItemCodeMappingDtoList'];
        this.inspectionType =res['projectDetails']['inspectionType'];
        this.projectName = res['projectDetails']['projectName'];
        this.projectCategoryCode = res['projectDetails']['categoryCode'];
        this.category = res['projectDetails']['category'];
        this.recordCount = res['projectDetails']['recordCount'];
        this.totalCount = res['projectDetails']['totalQuantity'];
        // this.checkCategoryForMixerZone();
      },
      err => {
        // alert("Internal issue to fetch the information");
        this.spinner.hide();
        this.responseMessage = "Internal issue to fetch the information";
        this.helperservice.openStaticModal('ConfirmDialog');
      }
    );
  }
  getClassifications(){
    this.httpService.getRequest('specialProjectApi/v1/getClassificationForTechnicians').subscribe(
      res => {
        this.classificationValues = res['items'];
      },
      err => {
        // console.log("no classificaton found");
        this.responseMessage = "No classification found.";
        this.helperservice.openStaticModal('ConfirmDialog');
      }
    );
  }

  getMixerZoneValues(){
    this.httpService.getRequest('specialProjectApi/v1/getMixerZones').subscribe(
      res => {
        this.mixerzoneValues = res['items'];
      },
      err => {
        // console.log("no classificaton found");
        this.responseMessage = "No classification found.";
        this.helperservice.openStaticModal('ConfirmDialog');
      }
    );
  }

  fetchRepairRecords() {
    this.spinner.show();
    const userId = localStorage.getItem('userId');
    this.httpService.getRequest(
      `standardInspectionApi/v1/getOpenRecordPageForTechnician`
      + `?pageNo=${this.count}&pageSize=100`
      + `&projectId=${this.firstParam}&userId=${userId}`
    ).subscribe(res => {
      this.spinner.hide();
      if (res['status'] === 'ERROR') {
        this.responseMessage = res['response'];
        this.helperservice.openStaticModal('ConfirmDialog');
        return;
      }
      this.repairRecords = res['response'];
      this.dataSource = new MatTableDataSource(this.repairRecords);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.hasMoreRecords = this.repairRecords.length === 100;
    }, err => {
      this.spinner.hide();
      this.responseMessage = 'Internal issue fetching records';
      this.helperservice.openStaticModal('ConfirmDialog');
    });
  }
  
  // ─── Pagination Controls ─────────────────────────────────────────────────────
  nextRecords() {
    if (!this.hasMoreRecords) return;
    this.count++;
    this.fetchRepairRecords();
  }
  
  previousRecords() {
    if (this.count > 1) {
      this.count--;
      this.fetchRepairRecords();
    } else {
      this.responseMessage = 'Already at first page.';
      this.helperservice.openStaticModal('ConfirmDialog');
    }
  }
  
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  categoryCode:any;
  mixerCategorySet:any =["F89","G11"];

  qualityOk(){
    console.log("ok");
    this.showClassification = false;
    this.showProblemFixed=  false;
    this.showMixerZone = false;
    this.mixerzoneValues=[];
    this.standardInspectionForm.controls['classification'].clearAsyncValidators();
    this.standardInspectionForm.controls['classification'].updateValueAndValidity();
    this.standardInspectionForm.controls['mixerzone'].clearAsyncValidators();
    this.standardInspectionForm.controls['mixerzone'].updateValueAndValidity();
  }

  qualityNotOk(){
    // console.log("not ok");
    // this.showClassification = true;
    // this.showProblemFixed=  true;
    // // this.showMixerZone = true;
    // this.showMixerZone = this.mixerCategorySet.includes(this.projectCategoryCode);
    // if(this.showMixerZone){
    //   this.getMixerZoneValues();
    // }
    // this.standardInspectionForm.controls['classification'].setValidators([Validators.required]);
    // this.standardInspectionForm.controls['classification'].updateValueAndValidity();
    // this.standardInspectionForm.controls['mixerzone'].setValidators([Validators.required]);
    // this.standardInspectionForm.controls['mixerzone'].updateValueAndValidity();

    console.log("not ok");
        this.showClassification = true;
        this.showProblemFixed = true;
        
        if (this.mixerCategorySet.includes(this.projectCategoryCode)) {
            this.showMixerZone = true;
            this.getMixerZoneValues();
            this.standardInspectionForm.controls["mixerzone"].setValidators([Validators.required]);
        } else {
            this.showMixerZone = false;
            this.standardInspectionForm.controls["mixerzone"].clearValidators();
        }
        this.standardInspectionForm.controls["mixerzone"].updateValueAndValidity();
    
        this.standardInspectionForm.controls["classification"].setValidators([Validators.required]);
        this.standardInspectionForm.controls["classification"].updateValueAndValidity();
    
        this.cdr.detectChanges();
  }

 

  standardInspectionSubmitForm(formDirective: FormGroupDirective) {
    if (!this.standardInspectionForm.valid) {
      this.helperservice.makeFormDirty(this.standardInspectionForm);
      console.log("validation failed");
      return;
      }

      const fd = new FormData();
      fd.append('userId', 'ISA_SPECIAL_PROJECT');

      if (this.filesList.length > 0) {
          for (let file of this.filesList) {
              fd.append('files', file);
          }
          this.uploadFiles(fd, formDirective);
      } else {
          this.saveStandardInspectionRecord([], formDirective);
      }
      }

      uploadImage(event: any) {
        var files = event.target.files;
        console.log(files);
    
        this.fileSizeError = '';
    
        for (var i = 0; i < files.length; i++) {
            var f = files[i];
            if (f.size > 5 * 1024 * 1024) {
                this.fileSizeError = `File ${f.name} exceeds the 5MB size limit.`;
                continue;
            }
    
            f.mediaSRC = URL.createObjectURL(f);
            this.filesList.push(f);
            console.log(this.filesList);
        }
    }

  closePopup() {
    this.helperservice.hideModal('ConfirmDialog');
  }

  

  uploadFiles(data: FormData, formDirective: FormGroupDirective) {
    this.spinner.show();
    this.httpService.uploadImageRequest('specialProject/uploadFiles', data,"STANDARD_INSPECTION").subscribe(
        res => {
            this.saveStandardInspectionRecord(res['fileUrl'], formDirective);
        },
        err => {
            this.spinner.hide();
            this.responseMessage = "Error occurred during file upload.";
            this.helperservice.openStaticModal('ConfirmDialog');
        }
    );
}

saveStandardInspectionRecord(fileUrls: string[], formDirective: FormGroupDirective) {
    this.spinner.show();
    const formData = this.standardInspectionForm.value;
    const date = new Date().toISOString().slice(0, 19);


    let postData = {
        projectId: this.firstParam,
        itemCode: formData.itemcode,
        inspectionType: this.inspectionType,
        holderNumber: formData.holderNumber,
        serialNumber: formData.serialNumber,
        quality: formData.label,
        description: formData.description ? formData.description : "",
        zoneList: formData.mixerzone ? formData.mixerzone : [],
        problemFixedStatus: formData.problem,
        startTime: date,
        createdBy: localStorage.getItem('userId'),
        fileUrls: fileUrls
    };

    if (formData.classification != null && formData.classification !== "") {
        postData["classification"] = formData.classification;
    }

    this.spinner.show();
    this.httpService.postRequest('standardInspectionApi/v1/saveStandardInspectionRecord', postData).subscribe(
        res => {
            this.spinner.hide();
            if (res['status'] === 'SUCCESS') {
                this.responseMessage = res['response'];
                // this.standardInspectionForm.reset();
                // formDirective.resetForm();
                const currentHolder = formData.holderNumber;
                const defaultValues = {
                  itemcode: '',
                  holderNumber: currentHolder,
                  serialNumber: '',
                  label: 'OK',
                  classification: '',
                  description: '',
                  problem: 'YES',
                  mixerzone: ''
                };
                this.standardInspectionForm.reset(defaultValues);
                formDirective.resetForm(defaultValues);
                this.filesList = [];
                this.recordCount++;
                this.fetchRepairRecords();
              const fileInput = document.getElementById("chooseFile") as HTMLInputElement;
              if (fileInput) {
                fileInput.value = "";
              }
                this.showClassification = false;
                this.showProblemFixed = false;
                this.standardInspectionForm.controls['label'].setValue('OK');
                this.standardInspectionForm.controls['problem'].setValue('YES');
                this.helperservice.openStaticModal('ConfirmDialog');
            } else {
                this.responseMessage = res['response'];
                this.helperservice.openStaticModal('ConfirmDialog');
            }
        },
        err => {
            this.spinner.hide();
            this.responseMessage = err.response;
            this.helperservice.openStaticModal('ConfirmDialog');
        }
    );
}

getRecordDetails(recordID) {
  this.recordDetailID = recordID;
  this.spinner.show();
  this.httpService
    .getRequest("standardInspectionApi/v1/getRecordDetailsForId?standardInspectionRecordId=" + recordID)
    .subscribe(
      (res) => {
        this.spinner.hide();
        if (res['status'] === "SUCCESS") {
          const recordDetails = res['response'];
          this.recordDetailsByID = recordDetails.serialNumber;
          this.recordDetailsHolderNumber = recordDetails.holderNumber;
          this.recordDetailDescription = recordDetails.description;
          this.recordDetailstartDate = this.formatDateUTC(new Date(res["response"].startTime));
          this.recordDetailItemCode = recordDetails.itemCode;
            this.recordDetailClassification = recordDetails.classification;
            this.recordDetailQuality = recordDetails.quality;
            this.recordDetailProblemFixed = recordDetails.problemFixedStatus;
          this.recordDetailfileUrls = recordDetails.fileUrls;
          console.log("fetched image",this.recordDetailfileUrls)
          this.recordDetailcloseRecord = recordDetails.createdBy;
           this.helperservice.openStaticModal("seeProject-Dialog");
           
           this.recordDetailMixerZone = recordDetails.zoneList;
           if (this.mixerCategorySet.includes(this.projectCategoryCode)) {
            this.showMixerZone = true;
          
        } else {
            this.showMixerZone = false;
        }
        } else {
          this.responseMessage = res['response'];
          this.helperservice.openStaticModal('ConfirmDialog');
        }
      },
      err => {
        this.spinner.hide();
        this.responseMessage = "Internal issue to fetch the information";
        this.helperservice.openStaticModal('ConfirmDialog');
      }
    );
}



  closeRecordModal(){
    this.helperservice.hideModal("seeProject-Dialog");
  }

  closeRecord(){
    this.recordDetailID;
    var dateTime = new Date().toISOString();
    console.log(dateTime);
    this.spinner.show();
        let postData = {
          "projectId": this.firstParam,
          "recordId": this.recordDetailID,
          "endTime": dateTime
        };
        console.log("PostData : "+JSON.stringify(postData));
        this.httpService.postRequest('standardInspectionApi/v1/closeRecord', postData).subscribe(
          res => {
            this.helperservice.hideModal("seeProject-Dialog");
            this.spinner.hide();
            this.fetchRepairRecords();
            console.log("look here",res);
          },
          err => {
            this.spinner.hide();
            this.responseMessage = err.response;//ask
            this.helperservice.openStaticModal('ConfirmDialog');
          }
        );
  }


  editComments(){
    this.spinner.show();
    let postData = {
      "projectId": this.firstParam,
      "recordId": this.recordDetailID,
      "description": this.recordDetailDescription
    };
    console.log("PostData : "+JSON.stringify(postData));
    this.httpService.postRequest('standardInspectionApi/v1/updateRecordDescription', postData).subscribe(
      res => {
        this.helperservice.hideModal("seeProject-Dialog");
        this.spinner.hide();
        // alert("Comments Updated Successfully");
        this.responseMessage = "Comments Updated Successfully"
        this.helperservice.openStaticModal('ConfirmDialog');
        this.fetchRepairRecords();
        console.log(res);
      },
      err => {
        this.spinner.hide();
        this.responseMessage = err.response;//ask
        this.helperservice.openStaticModal('ConfirmDialog');
      }
    );
  }

  formatDateUTC(date: Date): string {
    if (!date) return '';
    const options: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: 'UTC' // Ensures UTC time
    };
    return new Intl.DateTimeFormat('en-GB', options).format(date).replace(',', '');
}


onCodeResult(resultString: string) {
  console.log("Scanned code:", resultString);
  if (!resultString) {
      console.error("No barcode detected");
      return;
  }

  if (this.scanStart) {
      this.standardInspectionForm.get('holderNumber').setValue(resultString);
  } else if (this.scanSerialStart) {
      this.standardInspectionForm.get('serialNumber').setValue(resultString);
  }

  let audio = new Audio("assets/mp3/beep-02.mp3");
  audio.load();
  audio.play();

  this.spinner.show();
  setTimeout(() => {
      this.spinner.hide();
      this.closeScanner();
  }, 2000);
}

onCamerasFound(devices: MediaDeviceInfo[]): void {
this.availableDevices = devices;
this.hasDevices = Boolean(devices && devices.length);
}
onDeviceSelectChange(selected: string) {
const device = this.availableDevices.find(x => x.deviceId === selected);
this.currentDevice = device || null;
}

onHasPermission(has: boolean) {
this.hasPermission = has;
}

onTorchCompatible(isCompatible: boolean): void {
this.torchAvailable$.next(isCompatible || false);
}

toggleTorch(): void {
this.torchEnabled = !this.torchEnabled;
}

toggleTryHarder(): void {
this.tryHarder = !this.tryHarder;
}

closeScanner() {
this.scanStart = false;
this.scanSerialStart = false;
this.helperservice.hideModal("barcodeScan");
} 
}